export enum ECMSBorderColors {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Keine = '',
}
export enum ECMSIconColors {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Schwarz = '#000000',
}
export enum ECMSDarkIconColors {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Weiß = '#FFFFFF',
}
export enum ECMSAlternateColors {
  'Nach Schriftfarbe' = 'Font',
  'Nach Primärfarbe' = 'Primary',
  Schwarz = '#000000',
}

export enum ECMSSecondaryAlternateColors {
  'Nach Schriftfarbe' = 'Font',
  'Nach Sekundärfarbe' = 'Secondary',
  Schwarz = '#000000',
}

export enum ECMSDarkColors {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Primärfarbe = 'Nach Primärfarbe',
}

export enum ECMSBorderRounding {
  Eckig = '0',
  Abgerundet = '0.375',
  Rund = '0.75',
}

export enum ECMSFontSize {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Standard = 'Standard',
}

export enum ECMSFontSizeBig {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Standard = '32',
}

export enum ECMSFontSizeMid {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Standard = '16',
}

export enum ECMSFontSizeSmall {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Standard = '14',
}

export enum ECMSFontColors {
  Benutzerdefiniert = 'Benutzerdefiniert',
  Weiß = '#FFFFFF',
  Schwarz = '#000000',
}

export enum ERegisterOptions {
  'Ich bin Neukunde' = 'Neukunde',
  'Ich bin Bestandskunde und habe eine Kundennummer' = 'Bestandskunde',
}
